import BackboneElement from './BackboneElement';
import Coding from './types/Coding';
import merge from 'lodash/merge';

export default class BN_SuperBillOccurenceCodeList extends BackboneElement {
    static __className = 'BN_SuperBillOccurenceCodeList';

    __objectStructure = {
        code: Coding,
        date: String,
    };

    constructor(constructJson, className = 'BN_SuperBillOccurenceCodeList') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
